import Compress from "compress.js";
const compressOptions = {
  size: 2,
  quality: 0.75,
  maxWidth: 1920,
  maxHeight: 1920,
  resize: true
};

const compress = new Compress();

export default function (file) {
  return compress.compress([file], compressOptions)
    .then((data) => {
      const file = data[0];
      const imgInBase64 = file.data;
      const imgExt = file.ext;
      const blob = Compress.convertBase64ToFile(imgInBase64, imgExt);
      const newFile = new File([blob], file.alt, {type: file.ext});
      newFile.base64Thumb = 'data:image/gif;base64,' + imgInBase64;
      newFile.isValid = true;
      return newFile;
    })
    .catch(() => 'Ошибка сжатия файла');
}
